import AsyncStorage from '@react-native-async-storage/async-storage';
import { isWeb } from '@/lib/platform';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { queryClient } from './queryClient';

let hasSetupPersistence = false;

export const setupQueryPersistence = () => {
  if (hasSetupPersistence) return;
  // Disable persistence on web for now to avoid hydration/localStorage issues
  if (isWeb) return;
  hasSetupPersistence = true;

  const persister = createAsyncStoragePersister({
    storage: AsyncStorage,
    key: 'pckm-query-cache-v2',
    throttleTime: 1000,
  });

  persistQueryClient({
    queryClient,
    persister,
    maxAge: 1000 * 60 * 30, // 30 minutes
    dehydrateOptions: {
      // Only persist successful queries to avoid caching errors
      shouldDehydrateQuery: (query) =>
        query.state.status === 'success' &&
        !(query.queryKey.length === 1 && query.queryKey[0] === '/api/auth/user'),
    },
  });
};
